var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeNative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bfd7ff",
    d: "M8,0L28,0A8,8 0,0 1,36 8L36,28A8,8 0,0 1,28 36L8,36A8,8 0,0 1,0 28L0,8A8,8 0,0 1,8 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0a64f9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.177,14.489a3.138,3.138 0,0 1,1.223 2.5v5.276a3.136,3.136 0,0 1,-3.136 3.136L13.732,25.401a3.136,3.136 0,0 1,-3.136 -3.136v-5.276a3.135,3.135 0,0 1,1.234 -2.493l4.264,-3.253a3.136,3.136 0,0 1,3.8 0l2.363,1.8v-2.067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a64f9",
    d: "M16.373,16.679a1.016,1.016 0,0 0,-1.016 1.016,1.016 1.016,0 0,0 1.016,1.016A1.016,1.016 0,0 0,17.39 17.695,1.016 1.016,0 0,0 16.373,16.679"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a64f9",
    d: "M19.626,16.679a1.016,1.016 0,0 0,-1.016 1.016,1.016 1.016,0 0,0 1.016,1.016A1.016,1.016 0,0 0,20.643 17.695,1.016 1.016,0 0,0 19.626,16.679"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a64f9",
    d: "M16.373,19.932a1.016,1.016 0,0 0,-1.016 1.016,1.016 1.016,0 0,0 1.016,1.016A1.016,1.016 0,0 0,17.39 20.948,1.016 1.016,0 0,0 16.373,19.932"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a64f9",
    d: "M19.626,19.932a1.016,1.016 0,0 0,-1.016 1.016,1.016 1.016,0 0,0 1.016,1.016A1.016,1.016 0,0 0,20.643 20.948,1.016 1.016,0 0,0 19.626,19.932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNative);
export default __webpack_public_path__ + "static/media/HomeNative.bc99b001b1b76cea39a9cb2a3c9dcb04.svg";
export { ForwardRef as ReactComponent };